import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  surveyPath: '',
  surveyCompleted: false
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState: initialState,
  reducers: {
    setSurveyPath(state, action) {
      state.surveyPath = action?.payload;
    },
    setSurveyCompleted(state, action) {
      state.surveyCompleted = action?.payload;
    }
  }
});

export const { setSurveyPath, setSurveyCompleted } = settingsSlice.actions;

export const surveyPath = (state) => state.settings.surveyPath;
export const selectSurveySettings = (state) => ({
  completed: state.settings.surveyCompleted,
  path: state.settings.surveyPath
});

export default settingsSlice.reducer;
